// Selector de foto: botón "Adjuntar foto" que sube la imagen a InsForge Storage
// y guarda la URL resultante. Muestra vista previa y permite cambiar/quitar.
import { useRef, useState, type ChangeEvent } from 'react';
import { subirFoto } from '../lib/api/storage';
import { useToast } from './Toast';

export function FotoUploader({ value, onChange }: { value: string; onChange: (url: string) => void }) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [subiendo, setSubiendo] = useState(false);
  const toast = useToast();

  const seleccionar = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setSubiendo(true);
    try {
      const url = await subirFoto(file);
      onChange(url);
    } catch (err) {
      toast.error('No se pudo subir la foto', (err as Error).message);
    } finally {
      setSubiendo(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <div className="field">
      <label>Foto (opcional)</label>
      <div className="foto-uploader">
        {value ? (
          <img className="foto-preview" src={value} alt="Vista previa" />
        ) : (
          <span className="foto-preview placeholder"><i className="fa-solid fa-image" /></span>
        )}
        <input ref={inputRef} type="file" accept="image/*" hidden onChange={seleccionar} />
        <button type="button" className={`btn secondary sm${subiendo ? ' loading' : ''}`} onClick={() => inputRef.current?.click()}>
          <i className="fa-solid fa-paperclip" /> {value ? 'Cambiar foto' : 'Adjuntar foto'}
        </button>
        {value ? (
          <button type="button" className="btn ghost sm" onClick={() => onChange('')}>
            <i className="fa-solid fa-xmark" /> Quitar
          </button>
        ) : null}
      </div>
    </div>
  );
}
